import { Translate } from '@chipinside/translate'
import { isNil } from 'lodash'

export const numberDisplayDefaultOptions: Intl.NumberFormatOptions = {
  maximumFractionDigits: 20,
}

export const intlLangMap = {
  en: 'en-US',
  es: 'es-ES',
  pt: 'pt-BR',
}

export function numberDisplay(
  value: any,
  options: Intl.NumberFormatOptions = numberDisplayDefaultOptions,
): string {
  const currentLang = Translate.getCurrentLanguage() ?? 'pt'

  const invalid = isNil(value) || value === ''

  const number = Number(value)

  if (invalid || !Number.isFinite(number)) return '-'

  return number?.toLocaleString(intlLangMap[currentLang], options)
}
